import {autoserialize} from 'cerialize';

export class ReservationRouteSummary {

  @autoserialize
  reservationId: number;

  @autoserialize
  polyline: string;

  @autoserialize
  distance: number;

  @autoserialize
  duration: number;

}
